RivalIQ.apps.Shell.module('views', function (views, App, Backbone, Marionette, $, _, s) {

    'use strict';

    const MIN_COMPANY_SETS_FOR_SEARCH = 10;

    views.SingleCompanyDropdownButton = Marionette.ItemView.extend({
        tagName: 'div',

        attributes: {
            style: 'width: 100%'
        },

        behaviors: {
            MenuItem: {
                behaviorClass: App.behaviors.MenuItem,
                className: 'active'
            }
        },

        className: 'company-set-option no-click',
        template: '#singleCompanyDropdownButtonTemplate',

        ui: {
            clearIcon: '.x-clear',
            searchIcon: '.x-search',
            searchBar: '.item-filter',
            filterInput: '.x-item-filter',
            footerAction: '.x-footer-action',
            companySet: 'a.company-set',
            companySetsContainer: '.dropdown-item-list',
            tooltips: '[data-toggle="tooltip"]',
            parentMenuItem: 'a.show-only-company-set'
        },

        events: {
            'click @ui.clearIcon': 'onClearClicked',
            'click @ui.companySet': 'onCompanySetClicked',
            'mouseenter @ui.parentMenuItem': 'onEnter'
        },

        eventsNotToDebounce: {
            'keyup @ui.filterInput': 'onFilterKeyup'
        },

        templateHelpers: function () {

            return {
                s: s,
                minCompanySetsForSearch: MIN_COMPANY_SETS_FOR_SEARCH
            };
        },

        onDestroy: function () {
            const me = this;
            me.ui.tooltips.tooltip('destroy');
        },

        getSortedCompanySets: function () {
            const me = this;

            // focus company should sit at the top of the list
            const focusCompanyId = RivalIQ.state.view.get('focusCompanyId');
            const companySets = me.model.get('companySets');
            const onlyFocusCompanySet = _.find(companySets, {
                id: `${RivalIQ.state.companySets.onlyCompany}${focusCompanyId}`
            });

            return _.uniq(_.compact([onlyFocusCompanySet].concat(companySets)));
        },

        serializeData: function () {
            const me = this;

            const companySets = me.getSortedCompanySets();

            return {
                companySets: companySets,
                focusCompanyId: RivalIQ.state.view.get('focusCompanyId'),
                activeCompanySetId: RivalIQ.state.view.get('companySetDescriptor')
            };
        },

        onRender: function () {
            const me = this;

            me.ui.tooltips.tooltip({
                delay: {
                    show: 1500,
                    hide: 0
                }
            });
        },

        onFilterKeyup: function (e) {
            const me = this;
            me.filterCompanySets();
        },

        onEnter: function () {
            const me = this;

            const activeCompanySet = RivalIQ.state.view.get('companySetDescriptor');
            if (!me._scrolledToActiveCompany && RivalIQ.state.utils.isOnlyCompanySet(activeCompanySet)) {
                const companyId = RivalIQ.state.utils.getCompanyIdFromSetId(activeCompanySet);
                $(`#company-id-${companyId}`).get(0)?.scrollIntoView();
                me._scrolledToActiveCompany = true;
            }
        },

        onClearClicked: function () {
            const me = this;

            me.ui.filterInput.val('');
            me.filterCompanySets();
        },

        filterCompanySets: function () {
            const me = this;

            const filterText = me.ui.filterInput.val().trim().toLocaleLowerCase();
            me.ui.clearIcon.toggleClass('display-none', _.isEmpty(filterText));
            me.ui.searchIcon.toggleClass('display-none', !_.isEmpty(filterText));

            const companySets = me.getSortedCompanySets();

            _.each(companySets, function (companySet) {
                const show = _.includes(companySet.name.toLocaleLowerCase(), filterText);
                me.$el.find(`li#company-id-${companySet.companyId}`).toggleClass('display-none', !show);
            });
        },

        onCompanySetClicked: function (e) {
            const me = this;

            const model = me.model;
            const companySetId = me.$(e.currentTarget).data('set-id');
            const attributes = {
                companySetId: companySetId
            };

            model.set(attributes);
            me.triggerMethod('companySetSelected', model);
        }
    });

}, window.s);
